/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import ResponseToInterventionIcon from 'icons/ResponseToInterventionIcon';

const messages = defineMessages({
  title: {id: 'navigation.response-to-intervention'},
});

const ResponseToInterventionItem = () => (
  <RouteLinkItem
    iconBefore={ResponseToInterventionIcon}
    route="midas/students/response-to-intervention"
    title={messages.title}
  />
);

export default ResponseToInterventionItem;
